import * as Api from "@api";
import * as C from "@components";
import {HeroCardImageAlignment, HeroCardImageSize} from "@components";
import React from "react";
import {HeroSection, HeroSectionKeys, HeroSectionProps} from "../HeroSection/HeroSection";
import {ProductXLSeriesSvg} from "../ProductXLSeriesSvg/ProductXLSeriesSvg";

interface ProductXLHeroSectionProps extends Omit<HeroSectionProps, "bgColor" | "contentProps" | "textColor">
{
    pageContent: Api.Content<typeof HeroSectionKeys[number]>;
    heroImageAlignment?: HeroCardImageAlignment;
    heroImageSize?: HeroCardImageSize;
}

export const ProductXLHeroSection = ({ pageContent, heroImageAlignment = HeroCardImageAlignment.Full, heroImageSize, ...props }: ProductXLHeroSectionProps): React.FunctionComponentElement<ProductXLHeroSectionProps> =>
    <HeroSection
        {...props}
        bgColor={C.Color.GrayTextOnBlackDomina}
        contentProps={{
            pageContent,
            items: {
                "hero.eyebrow": {
                    node: <ProductXLSeriesSvg key={'ffff'} margins={{ all: { x: C.Margin.Auto, bottom: C.Margin.D20 }, ipad: { x: C.Margin.D0, bottom: C.Margin.D5 } }} />
                },
                "hero.headline": {
                    props: { margins: { bottom: C.Margin.D5 }, typography: C.Typography.MH1DH2 },
                },
                "hero.subhead": {
                    props: { typography: C.Typography.T2 },
                },
            },
        }}
        textColor={C.Color.MutedTan}
        heroImageAlignment={heroImageAlignment}
        heroImageSize={heroImageSize}
    />;
